import React, { useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead } from "./kit";

/// AYVO Ludo için ayrı Agora hesabı. Boş bırakılırsa AYVO'nun Agora ayarı kullanılır.
/// Sertifika hiçbir zaman geri gösterilmez; App ID maskeli gelir.
const kart = { background: "#fff", borderRadius: 14, padding: 18, boxShadow: "0 1px 3px #0001", marginBottom: 16, maxWidth: 640 };

export default function AyvoLudoAgora() {
  const [d, setD] = useState(null);
  const [appId, setAppId] = useState("");
  const [cert, setCert] = useState("");
  const [mesaj, setMesaj] = useState("");
  const [bekle, setBekle] = useState(false);
  const yukle = () => api.gappAgora().then((r) => r?.status && setD(r));
  useEffect(() => { yukle(); }, []);

  const kaydet = async (e) => {
    e.preventDefault();
    setBekle(true);
    const r = await api.gappAgoraSave({ appId: appId.trim(), certificate: cert.trim() });
    setBekle(false);
    setMesaj(r?.message || (r?.status ? "Kaydedildi" : "Olmadı"));
    if (r?.status) { setCert(""); setAppId(""); yukle(); }
  };
  const temizle = async () => {
    if (!window.confirm("AYVO Ludo'nun ayrı Agora ayarı silinsin mi? AYVO'nun Agora hesabı kullanılmaya başlanır.")) return;
    const r = await api.gappAgoraSave({ clear: true });
    setMesaj(r?.message || "");
    yukle();
  };

  return (
    <div>
      <PageHead title="AYVO Ludo – Agora" sub="AYVO Ludo sesli odaları ve Ludo maçı sesli sohbeti için ayrı Agora hesabı" />
      <div style={kart}>
        <h6 style={{ fontWeight: 800 }}>Şu an kullanılan</h6>
        {!d ? "…" : (
          <div style={{ fontSize: 14 }}>
            <div>Kaynak: <b style={{ color: d.active === "ayvoLudo" ? "#16a34a" : "#b45309" }}>{d.active === "ayvoLudo" ? "AYVO Ludo'nun kendi Agora hesabı" : "AYVO'nun Agora hesabı (yedek)"}</b></div>
            <div>Kullanılan App ID: <code>{d.activeAppId || "—"}</code></div>
            <div>AYVO Ludo App ID: <code>{d.appId || "girilmedi"}</code> · Sertifika: {d.certSet ? "kayıtlı ✓" : "girilmedi"}</div>
          </div>
        )}
      </div>
      <form style={kart} onSubmit={kaydet}>
        <h6 style={{ fontWeight: 800 }}>Agora bilgilerini gir</h6>
        <p style={{ fontSize: 13, color: "#64748B" }}>Agora Console → Project Management → projeyi aç. <b>App ID</b> ve <b>Primary Certificate</b> değerlerini yapıştır. Sertifikayı değiştirmeyeceksen boş bırak.</p>
        <label style={{ fontSize: 13, fontWeight: 700 }}>App ID</label>
        <input className="form-control mb-2" value={appId} onChange={(e) => setAppId(e.target.value)} placeholder="32 karakter" autoComplete="off" />
        <label style={{ fontSize: 13, fontWeight: 700 }}>Primary Certificate</label>
        <input className="form-control mb-3" type="password" value={cert} onChange={(e) => setCert(e.target.value)} placeholder={d?.certSet ? "kayıtlı — değiştirmek için yeni değeri gir" : "32 karakter"} autoComplete="new-password" />
        <div className="d-flex" style={{ gap: 8 }}>
          <button className="btn btn-primary" disabled={bekle || !appId}>{bekle ? "Kaydediliyor…" : "Kaydet"}</button>
          {d?.active === "ayvoLudo" && <button type="button" className="btn btn-outline-danger" onClick={temizle}>Ayrı hesabı kaldır</button>}
        </div>
        {mesaj && <div style={{ marginTop: 10, fontSize: 13 }}>{mesaj}</div>}
        <p style={{ fontSize: 12, color: "#94A3B8", marginTop: 12 }}>Değişiklik yeni girilen odalarda ve yeni başlayan maçlarda geçerli olur. Açık odalardaki kullanıcılar çıkıp girince yeni hesaba geçer. Ana AYVO uygulaması bundan etkilenmez.</p>
      </form>
    </div>
  );
}
